'use client';

import { Slider as HeroSlider } from '@heroui/react';
import { ReactNode } from 'react';

export interface SliderProps {
  children?: ReactNode;
  value?: number | number[];
  defaultValue?: number | number[];
  minValue?: number;
  maxValue?: number;
  step?: number;
  orientation?: 'horizontal' | 'vertical';
  isDisabled?: boolean;
  'aria-label'?: string;
  onChange?: (value: number | number[]) => void;
}

const SliderRoot = ({
  children,
  value,
  defaultValue,
  minValue,
  maxValue,
  step,
  orientation,
  isDisabled,
  'aria-label': ariaLabel,
  onChange,
}: SliderProps) => {
  return (
    <HeroSlider
      value={value}
      defaultValue={defaultValue}
      minValue={minValue}
      maxValue={maxValue}
      step={step}
      orientation={orientation}
      isDisabled={isDisabled}
      aria-label={ariaLabel}
      onChange={onChange}
    >
      {children}
    </HeroSlider>
  );
};

const Track = ({ children }: { children: ReactNode | ((props: any) => ReactNode) }) => (
  <HeroSlider.Track>{children as any}</HeroSlider.Track>
);

const Fill = () => <HeroSlider.Fill />;

const Thumb = ({ index }: { index?: number }) => (
  <HeroSlider.Thumb index={index} />
);

const Output = () => <HeroSlider.Output />;

export const Slider = Object.assign(SliderRoot, {
  Track,
  Fill,
  Thumb,
  Output,
});
